<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <div v-if="loginDefine.length > 1">
      <a-tabs default-active-key="0">
        <a-tab-pane v-for="(item, index) in loginDefine" :key="String(index)" :tab="item.name" force-rende>
          <component :is="item.component" @getLoginAccount="getLoginAccount" :agree="isAgreePrivacy"/>
        </a-tab-pane>
      </a-tabs>
    </div>
    <div v-else>
      <component :is="loginDefine[0].component" @getLoginAccount="getLoginAccount" :agree="isAgreePrivacy"/>
    </div>
    <!-- SAAS和商户版 -->
    <div v-if="['10009', '10016'].includes(logoUi.appId)">
      <Privacy :onAgreeChange="(val) => {
        this.agree=val;
      }"/>
    </div>
  </div>
</template>

<script>

import { message } from 'ant-design-vue';

import api from '@/api';
import { post } from '@/utils/http';

import { pointTools } from '@/utils/point';
import Baseunified from '@/utils/micro/baseunified';
import { getLogo } from '@/utils/intConfiguration';
import { getUiFitment } from '@/utils/accessResources';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
import AccountLogin from './accountLogin.vue';
import VerificationLogin from './verificationLogin.vue';
import CmhubLogin from '@/features/cmhub/components/CmhubLogin.vue';
// eslint-disable-next-line import/no-unresolved
import UserNameLogin from './useNameLogin.vue';
// eslint-disable-next-line import/no-unresolved
import ThirdLogin from './thirdLogin.vue';

import {
  setAccount,
  setUserSys,
  setUserZnEnv,
} from '../../login-handler';

import Privacy from './privacy.vue';

const baseModel = new Baseunified();
const { envList } = require('../../../../../config/dev.proxy');

export default {
  name: 'ZnLogin',
  beforeCreate() {
    if (process.env.NODE_ENV === 'development') {
      localStorage.removeItem('appId');
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AccountLogin,
    // eslint-disable-next-line vue/no-unused-components
    VerificationLogin,
    // eslint-disable-next-line vue/no-unused-components
    CmhubLogin,
    UserNameLogin,
    // eslint-disable-next-line vue/no-unused-components
    ThirdLogin,
    Privacy,
  },
  data() {
    return {
      logoUi: getLogo(),
      loginDefine: baseModel.getLoginDefine(),
      agree: false
    };
  },
  computed: {
    isAgreePrivacy() {
      if (['10009', '10016'].includes(this.logoUi.appId)) {
        return this.agree;
      }
      return true;
    }
  },
  created() {
    this.$root.$on('login-system-selected', this.refreshLoginDefine);
    pointTools.traceClick({
      event_type: 'page_view',
      content: {
        event_id: 'page_login',
        event_name: '登录页',
      },
    });
  },
  mounted() {
    // console.error(this.logoUi);
  },
  beforeDestroy() {
    this.$root.$off('login-system-selected', this.refreshLoginDefine);
  },
  methods: {
    refreshLoginDefine() {
      this.loginDefine = baseModel.getLoginDefine();
    },
    // TODO线上缓存 （适配apaas+告警sdk apaas调整结构，统一网络库后 废弃）
    initenv() {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      function prdZnv() {
        // eslint-disable-next-line no-unused-vars
        let isProduct = true;
        envList.forEach((m) => {
          if (window.location.hostname.toString().includes(m)) {
            isProduct = false;
            setUserZnEnv(m);
            setUserSys(_this.logoUi.appId);
          }
        });
        if (isProduct) {
          isProduct = _this.laneFitting();
        }
        if (isProduct) {
          setUserZnEnv('product');
          // 本地ng转发后 appId未定义问题
          // eslint-disable-next-line no-underscore-dangle
          const _host = window.location.hostname.toString();
          if (!_host.includes('192') && !_host.includes('localhost')) {
            setUserSys(_this.logoUi.appId);
          }
        }
      }
      if (process.env.NODE_ENV !== 'development') {
        prdZnv();
      }
    },
    // TODO 泳道环境测试 适配方法 仅供泳道验证使用
    laneFitting() {
      let isProduct = true;
      const lantEnv = ['test', 'dev'];
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;
      lantEnv.forEach((m) => {
        if (window.location.hostname.toString().includes(m)) {
          isProduct = false;
          // eslint-disable-next-line no-unused-expressions
          m === 'dev' ? setUserZnEnv('dev') : setUserZnEnv('sit');
          setUserSys(_this.logoUi.appId);
        }
      });
      return isProduct;
    },
    // 获取用户信息
    getLoginAccount(loginRes) {
      this.initenv();
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
      })
        .then((res) => {
          // 之后缓存菜单需要参数
          setAccount(res, loginRes);

          // 同意最新用户协议，目前只有 SASS 接入
          if (!isCustomerSaasPrivate() && ['10016'].includes(loginRes.appId)) {
            // SAAS 有用户协议
            post(api.getAgreementList, { appId: loginRes.appId }).then((agreeRes) => {
              if (agreeRes && agreeRes.agreementList) {
                post(api.forceUserToAgree, { appId: '10016', agreementList: agreeRes.agreementList });
              }
            });
          }

          getUiFitment().finally(() => {
            if (res.id) {
              this.$store.commit('emptyTab');
              this.$router.push('/');
            }
          });
        });
    },
  },
};
</script>
